import { AbstractControl, UntypedFormControl } from '@angular/forms';

export function moneyValidator(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && !control.value
    .match(/^(\d{1,8}\.\d{1,2}|\d+)$/)) {
    return { 'invalidMoney': true };
  }
  return null;
}

export function accountValidator(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && !control.value
    .match(/^[0-9]{3,16}$/)) {
    return { 'invalidAccount': true };
  }
  return null;
}
